import React from 'react';
import PropTypes from 'prop-types';
import WarningAmber from '@mui/icons-material/WarningAmber';

const ErrorMessage = (props) => {

    return (
        <section className="section form-container full margin-top-3">
            <div className="text-center">
                <WarningAmber
                    color="warning"
                    fontSize="large"
                />
            </div>

            {(props.title) && (
                <h3 className="margin-top-1 text-center">
                    {props.title}
                </h3>
            )}

            {(props.message) && (
                <p className="margin-bottom-2 text-center">{props.message}</p>
            )}

            {(props.url) && (
                <div className="button-group align-center">
                    <a
                        className="button primary"
                        href={props.url}
                    >
                        Back
                    </a>
                </div>
            )}
        </section>
    );
}

ErrorMessage.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    url: PropTypes.string,
}

ErrorMessage.defaultProps = {
    title: 'You do not have permission to access this page',
}

export default ErrorMessage;
